import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { Controller } from 'react-hook-form';

import { Typography } from '@/shared/components/atoms/Typography';

interface Props {
  disabled?: boolean;
  id: string;
  describe?: boolean;
  describtion?: string;
  valueAsBinary?: boolean;
  onChangeEffect?: (value: boolean | number) => void;
}

const SwitchButton: React.FC<Props> = ({
  disabled,
  id,
  describe = true,
  describtion,
  valueAsBinary,
  onChangeEffect,
}) => {
  const {
    t,
    i18n: { dir },
  } = useTranslation();

  const activeClasses = {
    track: classNames(
      'h-24',
      disabled
        ? 'bg-[#D9DBDF] border-[#D9DBDF]'
        : 'bg-primary-default border-primary-default'
    ),
    handle: classNames(
      disabled ? 'bg-background-neutral-100' : 'bg-white',
      dir() === 'ltr' ? 'right-[2px]' : 'left-[2px]'
    ),
  };
  const inactiveClasses = {
    track: classNames(
      disabled
        ? 'border-[#CED2D6] bg-neutralVariant-95'
        : 'bg-background-neutral-99 border-sm border-outline-variant'
    ),
    handle: classNames(
      disabled ? 'bg-[#B8BFC9]' : 'bg-surface-10',
      dir() === 'ltr' ? 'left-[2px]' : 'right-[2px]'
    ),
  };

  return (
    <Controller
      name={id}
      render={({ field: { onChange, value } }) => (
        <div className='flex items-center gap-16'>
          <div
            className={classNames(
              disabled ? 'pointer-events-none' : 'cursor-pointer',
              'relative h-24 w-48 rounded-2xxxxl border-sm transition-all duration-300',
              value ? activeClasses.track : inactiveClasses.track
            )}
            onClick={() => {
              const val = valueAsBinary ? Number(!value) : !value;
              if (onChangeEffect) onChangeEffect(val);
              onChange(val);
            }}
          >
            <div
              className={classNames(
                'absolute top-1/2 h-16 w-16 -translate-y-1/2 rounded-full transition-all duration-300',
                value ? activeClasses.handle : inactiveClasses.handle
              )}
            ></div>
          </div>
          {describe && (
            <Typography variant='subtitle2' weight='medium'>
              {describtion ?? t(value ? 'On' : 'Off')}
            </Typography>
          )}
        </div>
      )}
    />
  );
};

export default SwitchButton;
